import React from 'react';
import { TreeNodeType } from '../../../../../../lib/types/types';
import AbschlussAbschlussKreativ, { getFormStrucAbschlussAbschlussKreativ } from './content/AbschlussAbschlussKreativ';
import DurchfuehrungAbschlussKreativ, { getFormStrucDurchfuehrungAbschlussKreativ } from './content/DurchfuehrungAbschlussKreativ';
import FoerderZielenAbschlussKreativ, { getFormStrucFoerderZielenAbschlussKreativ } from './content/FoerderZielenAbschlussKreativ';
import MessungDesErfolgsAbschlussKreativ, { getFormStrucMessungDesErfolgsAbschlussKreativ } from './content/MessungDesErfolgsAbschlussKreativ';
import OeffentlichMarketingAbschlussKreativ, {
	getFormStrucOeffentlichMarketingAbschlussKreativ,
} from './content/OeffentlichMarketingAbschlussKreativ';
import VerstetigungAusblickAbschlussKreativ, {
	getFormStrucVerstetigungAusblickAbschlussKreativ,
} from './content/VerstetigungAusblickAbschlussKreativ';
import WeitereInfoAbschlussKreativ, { getFormStrucWeitereInfoAbschlussKreativ } from './content/WeitereInfoAbschlussKreativ';

export const TreeStructureAbschlussKreativ = (): TreeNodeType[] => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Durchführung des Vorhabens',
			content: <DurchfuehrungAbschlussKreativ />,
			formStruc: getFormStrucDurchfuehrungAbschlussKreativ(),
		},
		{
			label: 'Beitrag zu den angestrebten Förderzielen',
			content: <FoerderZielenAbschlussKreativ />,
			formStruc: getFormStrucFoerderZielenAbschlussKreativ(),
		},
		{
			label: 'Messung des Erfolgs',
			content: <MessungDesErfolgsAbschlussKreativ />,
			formStruc: getFormStrucMessungDesErfolgsAbschlussKreativ(),
		},
		{
			label: 'Öffentlichkeitsarbeit, Marketingmaßnahmen',
			content: <OeffentlichMarketingAbschlussKreativ />,
			formStruc: getFormStrucOeffentlichMarketingAbschlussKreativ(),
		},
		{
			label: 'Verstetigung und Ausblick',
			content: <VerstetigungAusblickAbschlussKreativ />,
			formStruc: getFormStrucVerstetigungAusblickAbschlussKreativ(),
		},
		{
			label: 'Weitere Informationen',
			content: <WeitereInfoAbschlussKreativ />,
			formStruc: getFormStrucWeitereInfoAbschlussKreativ(),
		},
		{ label: 'Abschluss', content: <AbschlussAbschlussKreativ />, formStruc: getFormStrucAbschlussAbschlussKreativ() },
	];

	return treeNodes;
};
